(function () {
    'use strict';

    angular.module("imApp").factory("selectArticlesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSelectArticles: function (parms) {
                return $ihttp.post({
                    method: 2458,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
